export default __webpack_public_path__ + "static/klaszczynski-93b2e185cf4684bad0539bca71f2677d.jpg";